module.exports = __webpack_public_path__ + "static/media/m (9).738e7727.jpg";